import ButtonItem, { ButtonItemProps } from './ButtonItem';

export type { ButtonItemProps };
export default ButtonItem;
